export function loadPaySelection(response, orderId, discountValue = 0) {
    let widget = new window.pw.PayWidget();
    const metaObj = {
        MetaData: {
            PaymentType: "Pay",
        },
        PaymentRequest: {
            OrderId: orderId.toString(),
            Amount: (parseFloat(response.sum) * ((100 - discountValue) / 100)).toFixed(2),
            Currency: "RUB",
            Description: response.description,
            RebillFlag: true,
            ExtraData: {
                ReturnUrl: window.shared.state.site + '/instashpion/dashboard/order-success'
            }
        },
        CustomerInfo: {
            Email: response.client_email
        }
    }
    if (!window.shared.isTest) {
        metaObj['ReceiptData'] = {
            timestamp: response.created_at,
                receipt: {
                client: {
                    email: response.client_email
                },
                company: {
                    sno: 'patent',
                        inn: response.company_inn,
                        payment_address: response.company_address,
                },
                items: [
                    {
                        name: response.description,
                        price: response.sum,
                        quantity: 1,
                        sum: response.sum,
                        payment_method: 'full_prepayment',
                        payment_object: 'service',
                        vat: {
                            type: 'none'
                        }
                    }
                ],
                    payments: [
                    {
                        type: 1,
                        sum: response.sum
                    }
                ],
                    total: response.sum
            }
        }
    }
    widget.pay(
        {
            // serviceId - Идентификатор ТСП
            serviceId: window.shared.shopId,
            // key - public key из личного кабинета мерчанта
            key: window.shared.publicKey,
            // logger - для включения расширенного логирования при отладке
            logger: window.shared.isTest,
        },
        metaObj,
        {
            onSuccess: function(res) {
                console.log("onSuccess from shop", res);
                if (res.returnUrl) window.location.href = res.returnUrl;
            },
            onError: function(res) {
                console.log("onFail from shop", res);
            },
            onClose: function(res) {
                console.log("onClose from shop", res);
            },
        },
        {only2Level: true} // необязательный параметр, необходим для корректной работы при наличии сайтов с поддоменами
    );
}